const mistakes = [
  'объявить изменения и не объяснить причины;',
  'считать, что сотрудники сами разберутся;',
  'не подготовить руководителей среднего звена;',
  'внедрять сразу слишком много изменений;',
  'игнорировать сопротивление;',
  'воспринимать вопросы сотрудников как саботаж;',
  'не обучить новым инструментам;',
  'не дать времени на адаптацию;',
  'не контролировать внедрение;',
  'не фиксировать новые стандарты;',
  'требовать нового поведения, продолжая поощрять старое;',
  'отказаться от изменений при первых трудностях.',
];

export default function ManagerMistakes() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Типичные ошибки руководителей
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Что мешает изменениям прижиться и возвращает компанию к старому способу работы
        </p>

        <div className="grid sm:grid-cols-2 gap-3 max-w-4xl mx-auto mb-12">
          {mistakes.map((m, i) => (
            <div key={i} className="flex items-start gap-2.5 bg-white rounded-lg border border-gray-200 p-4 hover:border-teal-300 transition-colors">
              <i className="ri-close-circle-line text-red-400 mt-0.5 flex-shrink-0"></i>
              <span className="text-sm text-gray-700 leading-relaxed">{m}</span>
            </div>
          ))}
        </div>

        <div className="bg-teal-50 rounded-xl border border-teal-200 p-6 md:p-8 max-w-4xl mx-auto text-center">
          <p className="text-base text-teal-800 leading-relaxed font-semibold">
            Руководитель не может требовать устойчивого нового поведения, если компания не создала условия для его появления.
          </p>
        </div>
      </div>
    </section>
  );
}